// src/utils/validation.js

export function validatePhoneNumber(phone) {
  // Simple regex for 10-digit phone number (adjust as needed)
  const phoneRegex = /^[0-9]{10}$/;
  return phoneRegex.test(phone);
}

export function validatePassword(password) {
  // Password min 8 chars, at least one letter and one number, allows @#$%^&*!
  const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@#$%^&*!]{8,}$/;
  return passwordRegex.test(password);
}

export function validateEmail(email) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};